export default "__VITE_ASSET__D0n4dfo6__"